import * as actions from '../pureActions/certificateActions';
import {
  countriesAndRegistriesGet,
  exportCertificatesPost,
  transferCertificatesPost,
} from '../actionHelpers/endpoints';
import { createAsyncAction } from '../../utils/asyncHelpers';
import {
  EXPORT_CERTIFICATES,
  GET_COUNTRIES_AND_REGISTRIES,
  TRANSFER_CERTIFICATES,
} from '../../constants/actionTypes/transferringCertificatesActionTypes';

export const selectReceiver = (accountId) => (dispatch) =>
  dispatch(actions.selectReceiver(accountId));

export const selectCountryOrRegistry = (destinationObject) => (dispatch) =>
  dispatch(actions.selectCountryOrRegistry(destinationObject));

export const transferCertificates = createAsyncAction(
  TRANSFER_CERTIFICATES,
  transferCertificatesPost
);

export const exportCertificates = createAsyncAction(
  EXPORT_CERTIFICATES,
  exportCertificatesPost
);

export const getCountriesAndRegistries = createAsyncAction(
  GET_COUNTRIES_AND_REGISTRIES,
  countriesAndRegistriesGet
);
